import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e594aa30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile-thumbnails" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "label" }

import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import useLoadSlides from '@/hooks/useLoadSlides'
import useSlideHandler from '@/hooks/useSlideHandler'

import Draggable from 'vuedraggable'
import ThumbnailSlide from '@/views/components/ThumbnailSlide/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileThumbnails',
  setup(__props) {

const slidesStore = useSlidesStore()
const { slides, slideIndex } = storeToRefs(slidesStore)

const { sortSlides } = useSlideHandler()

const { slidesLoadLimit } = useLoadSlides()
const changeSlideIndex = (index: number) => {
  slidesStore.updateSlideIndex(index)
}

// 拖拽调整顺序后进行数据的同步
const handleDragEnd = (eventData: { newIndex: number; oldIndex: number }) => {
  const { newIndex, oldIndex } = eventData
  sortSlides(newIndex, oldIndex)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Draggable), {
      class: "thumbnail-list",
      modelValue: _unref(slides),
      animation: 300,
      scroll: true,
      scrollSensitivity: 50,
      setData: null,
      itemKey: "id",
      delayOnTouchOnly: true,
      delay: 800,
      onEnd: handleDragEnd
    }, {
      item: _withCtx(({ element, index }) => [
        _createElementVNode("div", {
          class: _normalizeClass(["thumbnail-item", { 'active': _unref(slideIndex) === index }]),
          onClick: ($event: any) => (changeSlideIndex(index))
        }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(index + 1), 1),
          _createVNode(ThumbnailSlide, {
            class: "thumbnail",
            slide: element,
            size: 120,
            visible: index < _unref(slidesLoadLimit)
          }, null, 8, ["slide", "visible"])
        ], 10, _hoisted_2)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})